import React, { useState } from "react";
import NewProducerButton from '../settings/producers/NewProducerButton';
import classNames from "classnames";
import { Button } from "react-bootstrap";
import GridLocationModal from "./GridLocationModal";
import { BidTableHeaderProps } from "./bidTableProps";
import { localizeBid as localize } from "features/localization/localizeService";

const BidTableHeader: React.FC<BidTableHeaderProps> = (props) => {
    
    const [isColumnModalShowing, setShowColumnModal] = useState(false);

    return <div className={classNames("row", "table-header-row", { "table-header-row-collapsed": props.isCollapsed })}>
        <div className="col">
            <div className="page-sub-header">
                {props.children}
            </div>
        </div>
        <div className="col action-bar">
            <div className="pt-1 pr-1"><strong className="d-none d-md-inline">{localize("BidTableHeader_Header_AddOfferDescription")}</strong>
                {!props.isCustomer && <div className="d-none d-md-inline"><NewProducerButton /></div>}
                {props.hideLocationsButton !== true && <Button variant="link" onClick={() => setShowColumnModal(true)}>
                    <i className="material-icons">settings</i> {localize("BidTableHeader_Button_Locations")}
                </Button>}
                {
                    isColumnModalShowing &&
                        <GridLocationModal
                            isShowing={isColumnModalShowing}
                            onClose={() => setShowColumnModal(false)}
                            commodity={props.commodity}
                            locations={props.locations}
                            selectedCommoditySettings={props.selectedCommoditySettings}
                            saveRegionChanges={props.saveCommoditySettingsChanges}
                        />
                }
            </div>
        </div>
    </div>
};

export default BidTableHeader;